import React from 'react';
import PropTypes from 'prop-types';
import './DraftStatusHeader.css';

const DraftStatusHeader = ({ draftState }) => {
  const { currentPicker, round, pickInRound, timeLeft, isDraftComplete } = draftState;

  return (
    <div className="draft-status-header">
      <div className="status-item">
        <span className="status-label">STATUS:</span>
        <span className="status-value">
          {isDraftComplete ? 'DRAFT COMPLETE' : currentPicker?.username || 'N/A'}
        </span>
      </div>
      <div className="status-item">
        <span className="status-label">PICK:</span>
        <span className="status-value">{`Round ${round}, Pick ${pickInRound}`}</span>
      </div>
      {!isDraftComplete && (
        <div className="status-item timer">
          <span className="status-label">TIME LEFT:</span>
          <span className="status-value">{timeLeft}s</span>
        </div>
      )}
    </div>
  );
};

DraftStatusHeader.propTypes = {
  draftState: PropTypes.shape({
    currentPicker: PropTypes.shape({
      username: PropTypes.string,
    }),
    round: PropTypes.number,
    pickInRound: PropTypes.number,
    timeLeft: PropTypes.number,
    isDraftComplete: PropTypes.bool,
  }).isRequired,
};

export default DraftStatusHeader; 